if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        /*
        // Verificar si debe mostrarse el modal de regalo
        const shouldShowGiftModal = this.shouldShowGiftModal();
        console.log('[Gift Modal] ¿Debe mostrarse el modal?', shouldShowGiftModal);
        if (shouldShowGiftModal) {
          // Verificar si ya hay un regalo en el carrito
          const hasGift = await this.cartAlreadyHasGift();
          console.log('[Gift Modal] ¿Ya hay regalo en el carrito?', hasGift);
          if (!hasGift) {
            this.showGiftModal();
            return;
          }
        }
        */

        this.addToCart();
      }

      async cartAlreadyHasGift() {
        try {
          const modal = document.querySelector('#free-gift-modal');
          if (!modal) return false;
          const giftCards = modal.querySelectorAll('.free-gift-modal__product-card');
          const giftVariantIds = new Set();
          giftCards.forEach(card => {
            const vid = card.dataset.variantId;
            if (vid) giftVariantIds.add(Number(vid));
          });
          if (giftVariantIds.size === 0) return false;

          const cart = await fetch('/cart.js').then(r => r.json());
          return (cart.items || []).some(item => giftVariantIds.has(item.variant_id));
        } catch (e) {
          console.error('[Gift Modal] Error checking cart for gift:', e);
          return false;
        }
      }

      shouldShowGiftModal() {
        // Obtener datos del producto desde el DOM
        const productDataScript = document.querySelector('script[type="application/json"][data-product-variants]');
        if (!productDataScript) {
          console.log('[Gift Modal] No se encontró el script con datos de variantes');
          return false;
        }

        try {
          const variants = JSON.parse(productDataScript.textContent);
          const selectedVariantId = parseInt(this.variantIdInput.value, 10);
          
          console.log('[Gift Modal] Variantes encontradas:', variants.length);
          console.log('[Gift Modal] Variante seleccionada ID:', selectedVariantId);
          
          if (!variants || !Array.isArray(variants) || variants.length === 0) {
            console.log('[Gift Modal] No hay variantes válidas');
            return false;
          }

          // Buscar la opción de tamaño en los fieldset del formulario
          const optionFieldsets = document.querySelectorAll('fieldset.product-form__input');
          let sizeOptionIndex = -1;

          // Intentar encontrar la opción de tamaño de varias formas
          optionFieldsets.forEach((fieldset, index) => {
            const legend = fieldset.querySelector('legend');
            if (!legend) return;
            
            // Buscar el texto en diferentes lugares del legend
            const legendText = legend.textContent.toLowerCase().trim();
            const spanInLegend = legend.querySelector('span');
            const spanText = spanInLegend ? spanInLegend.textContent.toLowerCase().trim() : '';
            
            // Verificar si contiene palabras relacionadas con tamaño
            if (legendText.includes('tamaño') || legendText.includes('size') || 
                legendText.includes('tama') || spanText.includes('tamaño') || 
                spanText.includes('size') || spanText.includes('tama')) {
              sizeOptionIndex = index;
              console.log('[Gift Modal] Opción de tamaño encontrada en índice:', index, 'Texto:', legendText || spanText);
            }
          });

          // Si no encontramos una opción de tamaño explícita, usar la primera opción que no sea color
          if (sizeOptionIndex === -1) {
            // Buscar la primera opción que no sea color
            optionFieldsets.forEach((fieldset, index) => {
              const legend = fieldset.querySelector('legend');
              if (legend) {
                const legendText = legend.textContent.toLowerCase().trim();
                if (!legendText.includes('color') && sizeOptionIndex === -1) {
                  sizeOptionIndex = index;
                  console.log('[Gift Modal] Usando primera opción no-color como tamaño, índice:', index);
                }
              }
            });
            
            // Si aún no encontramos nada, usar índice 0
            if (sizeOptionIndex === -1) {
              sizeOptionIndex = 0;
              console.log('[Gift Modal] Usando índice 0 por defecto');
            }
          }

          // Obtener todos los valores únicos de tamaño de las variantes
          const sizeValues = new Set();
          variants.forEach(variant => {
            // Las variantes tienen option1, option2, option3
            const sizeValue = variant['option' + (sizeOptionIndex + 1)];
            if (sizeValue && sizeValue !== 'Default Title') {
              sizeValues.add(sizeValue);
            }
          });

          console.log('[Gift Modal] Valores únicos de tamaño encontrados:', sizeValues.size, Array.from(sizeValues));

          // Verificar si hay más de 2 tamaños
          if (sizeValues.size <= 2) {
            console.log('[Gift Modal] Solo hay', sizeValues.size, 'tamaños, no se muestra el modal');
            return false;
          }

          // Encontrar la variante seleccionada
          const selectedVariant = variants.find(v => v.id === selectedVariantId);
          if (!selectedVariant) {
            console.log('[Gift Modal] No se encontró la variante seleccionada');
            return false;
          }

          console.log('[Gift Modal] Variante seleccionada:', selectedVariant);

          // Encontrar el tamaño más grande (por precio, ya que generalmente el más grande es el más caro)
          // Filtrar solo variantes disponibles
          const availableVariants = variants.filter(v => v.available !== false);
          if (availableVariants.length === 0) {
            console.log('[Gift Modal] No hay variantes disponibles');
            return false;
          }

          const sortedByPrice = [...availableVariants].sort((a, b) => b.price - a.price);
          const largestVariant = sortedByPrice[0];
          
          console.log('[Gift Modal] Variante más grande (por precio):', largestVariant);
          console.log('[Gift Modal] ¿Es la seleccionada la más grande?', selectedVariant.id === largestVariant.id);
          
          // Verificar si la variante seleccionada es la más grande
          const shouldShow = selectedVariant.id === largestVariant.id;
          if (shouldShow) {
            console.log('[Gift Modal] ✅ Condiciones cumplidas, se mostrará el modal');
          }
          
          return shouldShow;
        } catch (e) {
          console.error('[Gift Modal] Error checking gift modal conditions:', e);
          return false;
        }
      }

      showGiftModal() {
        console.log('[Gift Modal] Intentando mostrar el modal...');
        const modal = document.querySelector('#free-gift-modal');
        if (modal) {
          console.log('[Gift Modal] Modal encontrado, mostrando...');

          // Guardar referencia del ProductForm para que el modal pueda usarla
          window.activeProductForm = this;

          if (typeof modal.show === 'function') {
            modal.show(this.submitButton);
          } else {
            modal.setAttribute('open', '');
            document.body.classList.add('overflow-hidden');
          }
        } else {
          console.error('[Gift Modal] No se encontró el modal #free-gift-modal');
          // Si no hay modal, continuar con el add to cart normal
          this.addToCart();
        }
      }

      addToCart(additionalItems = []) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const qtyInput = this.form.querySelector('[name="quantity"]') || this.form.querySelector('input[type="number"]');
        const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        const mainVariantId = this.variantIdInput.value;

        // Si hay productos adicionales (del modal de regalo), usar formato JSON
        if (additionalItems.length > 0) {
          const items = [{ id: String(mainVariantId), quantity: quantity }];
          additionalItems.forEach(item => {
            items.push({ id: String(item.variantId), quantity: 1 });
          });

          const config = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: items })
          };

          if (this.cart) {
            this.cart.setActiveElement(document.activeElement);
          }

          fetch(`${routes.cart_add_url}.js`, config)
            .then((response) => response.json())
            .then((response) => this.handleCartResponse(response, mainVariantId))
            .catch((e) => {
              console.error(e);
              this.handleCartError();
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
        } else {
          // Flujo normal sin productos adicionales
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => this.handleCartResponse(response, mainVariantId))
            .catch((e) => {
              console.error(e);
              this.handleCartError();
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
        }
      }

      handleCartResponse(response, variantId) {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          Permalink.reactive()
          const isEn = (window.Shopify?.locale === 'en') || (window.Shopify?.routes?.root || '').includes('/en');
          const origin = window.location?.origin || '';
          const path = isEn ? '/en/cart' : '/cart';
          window.location.href = `${origin}${path}`;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
          Permalink.reactive()
          const isEn = (window.Shopify?.locale === 'en') || (window.Shopify?.routes?.root || '').includes('/en');
          const origin = window.location?.origin || '';
          const path = isEn ? '/en/cart' : '/cart';
          window.location.href = `${origin}${path}`;
        }
      }

      handleCartError() {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          // No sobrescribir el texto del botón si ya tiene formato personalizado
          // El texto se actualiza dinámicamente desde buy-buttons.liquid
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}